import { cn } from '@/lib/utils'

const agentColors: Record<string, string> = {
  general_chat:
    'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  attributes_manager:
    'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  policy_crafter:
    'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200',
  identity_inspector:
    'bg-cyan-100 text-cyan-800 dark:bg-cyan-900 dark:text-cyan-200',
  discovery_analyst:
    'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200',
  compliance_auditor:
    'bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-200',
  supervisor:
    'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200',
}

export function AgentChip({ agentName }: { agentName: string }) {
  const displayName = agentName
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium',
        agentColors[agentName] ?? agentColors.supervisor
      )}
    >
      {displayName}
    </span>
  )
}
